require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-abidjan-urban-transport-project-phase-2.json") })
        }
      }, "path---en-us-project-abidjan-urban-transport-project-phase-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-abidjan-urban-transport-project-phase-2!./.cache/json/en-us-project-abidjan-urban-transport-project-phase-2.json
// module id = 485
// module chunks = 231608221292675